
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Voucher(props) {
    return (
        <SvgIcon {...props}>
            <path d="M10 14h2v4h-2v-4zm20-5v6.1c-.2-.1-.3-.1-.5-.1-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5c.2 0 .3 0 .5-.1V23c0 1.7-1.3 3-3 3H5c-1.7 0-3-1.3-3-3v-5.1c.2.1.3.1.5.1.8 0 1.5-.7 1.5-1.5S3.3 15 2.5 15c-.2 0-.3 0-.5.1V9c0-1.7 1.3-3 3-3h22c1.7 0 3 1.3 3 3zm-2 4.4V9c0-.6-.4-1-1-1H12v4h-2V8H5c-.6 0-1 .4-1 1v4.4c1.2.6 2 1.8 2 3.1s-.8 2.6-2 3.1V23c0 .6.4 1 1 1h5v-4h2v4h15c.6 0 1-.4 1-1v-3.4c-1.2-.6-2-1.8-2-3.1s.8-2.6 2-3.1z" />
        </SvgIcon>
    );
}

Voucher.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Voucher;
